import { render } from "./HundMensch.vue?vue&type=template&id=f38b2792"
import script from "./HundMensch.vue?vue&type=script&lang=js"
export * from "./HundMensch.vue?vue&type=script&lang=js"

import "./HundMensch.vue?vue&type=style&index=0&id=f38b2792&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__